import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
interface IOptions {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  observe?: 'body';
  params?:
    | HttpParams
    | {
        [param: string]: string | string[];
      };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private httpOptions;
  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders(this.getHeaders()),
    };
  }
  getHeaders(vivrAccessToken?: string | null): { [key: string]: string } {
    let headers: { [key: string]: string } = {
      'x-api-key': environment.xApiKey,
      'x-client-source': 'my-account-2',
      'Content-Type': 'application/json',
      'x-auth-type': 'auth0',
    };

    if (vivrAccessToken) {
      headers['Authorization'] = 'Bearer ' + vivrAccessToken;
    }

    return headers;
  }

  /**
   * @description This method is used to send the Get request to server
   * @param url
   * @param params
   * @returns
   */
  get<T>(url: string, options: IOptions = this.httpOptions): Observable<T> {
    return this.http.get<T>(url, options);
  }

  /**
   * @description This method is used to send the Post request to server
   * @param url
   * @param body
   * @param options
   * @returns
   */
  post<T>(
    url: string,
    body: unknown,
    options: IOptions = this.httpOptions
  ): Observable<T> {
    return this.http.post<T>(url, body, options);
  }

  /**
   * @description This method is used to send the Delete request to server
   * @param url
   * @param params
   * @returns
   */
  delete<T>(url: string, options: IOptions = this.httpOptions): Observable<T> {
    return this.http.delete<T>(url, options);
  }

  /**
   * @description This method is used to send the Put request to server
   * @param url
   * @param body
   * @param option
   * @returns
   */
  put<T>(
    url: string,
    body: unknown,
    options: IOptions = this.httpOptions
  ): Observable<T> {
    return this.http.put<T>(url, body, options);
  }
}
